<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="72"
        height="73"
        viewBox="0 0 72 73"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <g filter="url(#filter0_d_1_65)">
            <path
                d="M33.8824 3.22262C35.1928 2.46606 36.8072 2.46606 38.1176 3.22262L63.3272 17.7774C64.6376 18.5339 65.4449 19.9321 65.4449 21.4452V50.5548C65.4449 52.0679 64.6376 53.4661 63.3272 54.2226L38.1176 68.7774C36.8072 69.5339 35.1928 69.5339 33.8824 68.7774L8.67278 54.2226C7.36238 53.4661 6.55514 52.0679 6.55514 50.5548V21.4452C6.55514 19.9321 7.36238 18.5339 8.67278 17.7774L33.8824 3.22262Z"
                fill="#030C1D"
            />
            <path
                d="M33.6172 2.76367C35.0914 1.91254 36.9086 1.91254 38.3828 2.76367L63.5918 17.3193C65.0659 18.1705 65.9746 19.7431 65.9746 21.4453V50.5547C65.9746 52.2569 65.0659 53.8295 63.5918 54.6807L38.3828 69.2363C36.9086 70.0875 35.0914 70.0875 33.6172 69.2363L8.4082 54.6807C6.93405 53.8295 6.02539 52.2569 6.02539 50.5547V21.4453C6.02539 19.7431 6.93406 18.1705 8.4082 17.3193L33.6172 2.76367Z"
                stroke="currentColor"
                stroke-width="1.05882"
            />
        </g>
        <path
            d="M35.125 6.63867C35.6663 6.32623 36.3337 6.32623 36.875 6.63867L60.9893 20.5615C61.5307 20.8741 61.8642 21.452 61.8643 22.0771V49.9229C61.8642 50.548 61.5307 51.1259 60.9893 51.4385L36.875 65.3613C36.3337 65.6738 35.6663 65.6738 35.125 65.3613L11.0107 51.4385C10.4693 51.1259 10.1358 50.548 10.1357 49.9229V22.0771C10.1358 21.452 10.4693 20.8741 11.0107 20.5615L35.125 6.63867Z"
            stroke="currentColor"
            stroke-width="1.5"
        />
        <defs>
            <filter
                id="filter0_d_1_65"
                x="5.49631"
                y="1.59638"
                width="61.0074"
                height="70.9249"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2.11765" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.133333 0 0 0 0 0.168627 0 0 0 0 0.262745 0 0 0 1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_1_65"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1_65"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
</template>
